import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarContent from './SnackbarContent';
import SnackbarActionText from './SnackbarActionText';
import SnackbarTitle from './SnackbarTitle';
import SnackbarAction from './SnackbarAction';
import SnackbarSpinner from './SnackbarSpinner';

export default function SnackbarUpload({ message }) {
    const { t } = useTranslation('common');

    return (
        <SnackbarCard>
            <SnackbarLayout>
                <SnackbarContent>
                    <SnackbarActionText>{t('uploading')}</SnackbarActionText>
                    <SnackbarTitle>{message}</SnackbarTitle>
                </SnackbarContent>
                <SnackbarAction>
                    <SnackbarSpinner />
                </SnackbarAction>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarUpload.propTypes = {
    message: PropTypes.string.isRequired,
};
